import React, { useEffect, useState } from "react";
import { notifyError } from "../../helper";
import client from '../../api';
import { useParams } from "react-router-dom";
import BlockLoader from "../BlockLoader";
import { format } from "date-fns";

const CampaignActivity = (props) => {
    const {contactList} = props;
    const { campaignID } = useParams();
    const api = client();
    
    const [campaignActivities, setCampaignActivities] = useState([]);
    const [pageLoader, setPageLoader] = useState(true);
    const [ignoreSends, setIgnoreSends] = useState(false);

    // Pagination states
    const [offset, setOffset] = useState(0);
    const [limit] = useState(50); // API default limit
    const [totalCount, setTotalCount] = useState(0);
    const [loadingMore, setLoadingMore] = useState(false);

    const updateIgnoreSends = (e) => {
        setPageLoader(true);
        setIgnoreSends(e.target.value === "true"); // Convert the value to bool
        setOffset(0); // Reset pagination on filter change
        setCampaignActivities([]); // Reset activities
    };

    const getCampaignActivitiesData = async (newOffset = 0, append = false) => {
        try {
            setPageLoader(true);
            const response = await api.post('/v1/campaign/overview/activities', {
                campaign_id: campaignID,
                list_id: contactList,
                ignore_sends: ignoreSends,
                offset: newOffset,
                limit: limit
            });

            if (response.status === 200 || response.status === 201) {
                const data = response.data.campaignOverviewActivities;
                if (data !== null) {
                    setCampaignActivities(prev => append ? [...prev, ...data] : data);
                }
                setTotalCount(response.data.total_count);
                setOffset(newOffset + limit); // Update offset for next load
            }
        } catch (error) {
            notifyError('Error fetching campaign activities. Please try again.');
        } finally {
            setPageLoader(false);
            setLoadingMore(false);
        }
    };

    useEffect(() => {
        getCampaignActivitiesData();
    }, [ignoreSends,contactList]);

    const loadMoreActivities = () => {
        if (loadingMore || campaignActivities.length >= totalCount) return;
        setLoadingMore(true);
        getCampaignActivitiesData(offset, true);
    };

    return (
        <>
            <div className="activity-dd-wrap">
                <div className="activity-dd">
                    <select className="selectbox" value={ignoreSends} onChange={updateIgnoreSends}>
                        <option value={false}>All activities</option>
                        <option value={true}>Ignore sends</option>
                    </select>
                </div>
            </div>
            <div className="activity-wrap">
                {!pageLoader ? (
                    <div className="activity">
                        {campaignActivities.length ? (
                            <>
                                <ul>
                                    {campaignActivities.map((activity, i) => (
                                        <li key={i}>
                                            <i className={`activity-status email-deployed ${activity.event_type}`}></i>
                                            <div className="activity-date-time">{format(activity.created_at,'MMM dd')} at {format(activity.created_at,'hh:mm aa')}</div>
                                            <div className="activity-details" dangerouslySetInnerHTML={{ __html: activity.message }}></div>
                                        </li>
                                    ))}
                                </ul>
                                {campaignActivities.length < totalCount && (
                                    <div className="more-records">
                                        <button onClick={loadMoreActivities} disabled={loadingMore}>
                                            {loadingMore ? "Loading..." : <i className='bx bx-chevron-down'></i>}
                                        </button>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div>Activity data is not available</div>
                        )}
                    </div>
                ) : (
                    <div className="activity bg-white"><BlockLoader /></div>
                )}
            </div>
        </>
    );
};

export default CampaignActivity;
